export const CMS_PLACE_LIST = 'CMS_PLACE_LIST'
